import React from "react";
import { CalendarDaysIcon, ClipboardListIcon, PrinterIcon } from "lucide-react";
import { Accent, Container, SectionHeader } from "./ui";
import { steps } from "../data/content";
const icons = {
  calendar: CalendarDaysIcon,
  printer: PrinterIcon,
  clipboard: ClipboardListIcon
};
export function StepsSection() {
  return <section className="bg-white py-12 md:py-20" data-id="element-184" data-mp="19kxcq1mw4rpf">
      <Container data-id="element-185" data-mp="1ojhmo1aat7sb">
        <SectionHeader eyebrow="How it works" title={<>
              Open it. <Accent data-id="element-187" data-mp="1jlg3lgcvh8gu">Print it. Lead it.</Accent>
            </>} data-id="element-186" data-mp="1oiy54lok8let" />
        <ol className="grid grid-cols-1 gap-4 md:grid-cols-3" data-id="element-188" data-mp="1xckwlzlqj2i7">
          {steps.map((s, i) => {
          const Icon = icons[s.icon];
          return <li key={s.title} className="flex h-full flex-col rounded-2xl bg-sage p-6" data-id="element-189" data-mp="1tckiyh6gmvc7" data-mpi={i}>
                <div className="flex items-center justify-between" data-id="element-190" data-mp="27aiiigg4gn7n">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-white text-petrol" data-id="element-191" data-mp="22c78o5ptucpf">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-192" data-mp="2cp2gmusycjlo" />
                  </span>
                  <span className="font-display text-[44px] font-extrabold leading-none text-petrol/40" data-id="element-193" data-mp="2hndstc6pz672">{i + 1}</span>
                </div>
                <h3 className="mt-5 font-display text-[26px] font-bold uppercase leading-none text-petrol" data-id="element-194" data-mp="2mo1o4a1ze973">{s.title}</h3>
                <p className="mt-2 text-base text-ink" data-id="element-195" data-mp="2vmvjjx3kstj2">{s.description}</p>
              </li>;
        })}
        </ol>
      </Container>
    </section>;
}